import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";

/**
 * Renderiza un elemento de navegación dentro de un menú desplegable.
 *
 * El componente encapsula la estructura de un elemento de menú compuesto por
 * un enlace (`Link`) y un icono opcional. Se utiliza para mantener una
 * apariencia y comportamiento consistentes entre las distintas opciones del
 * Header.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {boolean} props.visible - Indica si el menú se encuentra visible para aplicar la clase correspondiente.
 * @param {string} props.to - Ruta de navegación del enlace.
 * @param {string} [props.icon] - Identificador del icono de Iconify que se mostrará antes del contenido.
 * @param {React.ReactNode} props.children - Contenido que se renderiza dentro del enlace.
 * @param {Function} [props.onClick] - Función que se ejecuta al hacer clic sobre el elemento.
 * @param {string} [props.className=""] - Clases CSS adicionales para personalizar el enlace.
 *
 * @returns {JSX.Element} MenuItem
 */
export const MenuItem = ({
    visible,
    to,
    icon,
    children,
    onClick,
    className = "",
}) => (
    <li
        className={`${visible ? "activeMode" : "inactiveMode"}`}
        role="none"
    >
        <Link
            to={to}
            onClick={onClick}
            className={`${className}`}
            role="menuitem"
        >
            {icon && <Icon icon={icon} width={20} className="mr-3" />}
            {children}
        </Link>
    </li>
);
